(() => {
  const init = () => {
    const header = document.querySelector('.sf-header-section');
    if (header && !header.dataset.sfObserved) {
      header.dataset.sfObserved = 'true';
      const offset = () => document.documentElement.style.setProperty('--sf-header-offset', `${header.getBoundingClientRect().height + 18}px`);
      offset();
      if ('ResizeObserver' in window) new ResizeObserver(offset).observe(header);
    }
  };
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-sf-open-search]')) return;
    const search = document.querySelector('.sf-search-details');
    if (!search) return;
    search.open = true;
    search.querySelector('input[type=search]')?.focus();
    document.querySelectorAll('.sf-mobile-menu[open]').forEach(menu => { menu.open = false; });
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
